test = {
  haha: function(){
    alert('haha');
  }
};



// WEBPACK FOOTER //
// ./src/static/test.js